<template>
  <div :loading="loading">
    <div class="fixedButton">
      <vxe-button class="examineButton" @click="ReturnFun">返回</vxe-button>
      <vxe-button v-if="approveBtnType === '1'" v-permission="['signIndex:startApproveBtn']" class="examineButton" status="primary" @click="handleApprove(0)">发起审批</vxe-button>
      <vxe-button v-if="approveBtnType === '3'" class="examineButton" status="primary" @click="handleApprove(5)">重新发起审批</vxe-button>
      <vxe-button v-if="approveBtnType === '2'" class="examineButton" status="primary" @click="handleApprove(1)">同意</vxe-button>
      <vxe-button v-if="approveBtnType === '2'" class="examineButton" status="warning" @click="handleApprove(2)">退给上一审批人</vxe-button>
      <vxe-button v-if="approveBtnType === '2'" class="examineButton" status="danger" @click="handleApprove(3)">驳回</vxe-button>
      <vxe-button v-if="approveBtnType === '2'" class="examineButton" status="danger" @click="handleApprove(6)">不同意</vxe-button>
      <vxe-button v-if="approveBtnType === '2'" class="examineButton" @click="handleApprove(4)">转派</vxe-button>
    </div>
    <div class="CertificateReleaseApplicationBox scrollBars" :style="`height:${$store.state.app.height - 80}px;`">
      <el-collapse v-model="activityInfo" class="collapse-box" style="margin-bottom:10px">
        <el-collapse-item class="collapseItem" title="活动信息">
          <!-- 活动计划信息 -->
          <ActivityMaintenanceInformation :data="activity" />
        </el-collapse-item>
      </el-collapse>
      <ActivityReportingInformation :data="signData" :activity="activity" :file-list="fileList" :approveBtnType="approveBtnType" :priceDiff="priceDiff"/>
      <el-collapse v-model="collapseNumber" class="collapse-box" style="margin-bottom:10px">
        <el-collapse-item class="collapseItem" title="提报审核历史" name="default">
          <el-table :data="findHistTasksData" :loading="approveLoading" border stripe style="width: 100%">
            <el-table-column prop="displayName" label="审核部门" />
            <el-table-column prop="operatorName" label="审核人" />
            <el-table-column prop="finishTime" label="审核时间" />
            <!-- <el-table-column prop="amounts" label="申请费用(元)" align="right">
              <template #default="{ row }">
                <span v-if="row.amounts">
                  {{ row.amounts | toThousandNumFilter }}
                </span>
              </template>
            </el-table-column> -->
            <el-table-column prop="approveCost" label="提报审核费用(元)" >
              <template #default="{ row }">
                <span v-if="row.approveCost">
                  {{ row.approveCost | toThousandNumFilter }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="operateType" label="操作类型" />
            <el-table-column prop="approveMsg" label="审核意见" />
          </el-table>
        </el-collapse-item>
      </el-collapse>
    </div>
    <el-dialog title="审批信息" :visible.sync="dialogVisible" width="40%">
      <div v-if="approveTypeName === '转 派'" class="demo-input-suffix" style="padding-bottom: 20px;">
        转派人：
        <el-input v-model="operatorUser" placeholder="请选择转派的用户" style="width:35%" @focus="chooseUser" />
      </div>
      <div v-if="approveTypeName === '同 意'" class="demo-input-suffix" style="padding-bottom: 20px;">
        审核金额：
        <el-input-number v-model="approveCost" :precision="2" controls-position="right" :step="0.1" :min="0.00" :max="9000000000000" :controls="false" />
        <!-- <el-input v-model="approveCost" maxlength="13" style="width:35%" oninput="value=value.replace(/\D/g, '')" /> -->
      </div>
      <el-input
        v-model="approveMsg"
        @input="gettotalCost"
        type="textarea"
        placeholder="请输入审批意见"
        maxlength="300"
        show-word-limit
      />
      <span v-if="approveValFalse" style="color:red">审批意见不能为空</span>
      <span slot="footer" class="dialog-footer">
        <vxe-button :loading="approveBtnLoading" status="primary" @click="approve()">{{ approveTypeName }}</vxe-button>
        <vxe-button @click="dialogVisible = false">取 消</vxe-button>
      </span></el-dialog>

    <el-dialog title="选择用户" :visible.sync="userDialogVisible" width="75%">
      <div style="margin-bottom: 20px">
        <el-input v-model="userName" placeholder="输入用户名称" clearable :style="{ width: '80%' }" @change="handleFilter" />
        <vxe-button status="primary" icon="el-icon-search" class="filter-search-item" style="float: right" @click="handleFilter">查询</vxe-button>
      </div>
      <vxe-table
        ref="Xuser"
        border
        show-header-overflow
        show-overflow
        :column-config="{ resizable: true }"
        stripe
        round
        :loading="userLoading"
        max-height="350"
        align="center"
        :scroll-y="{ enabled: false }"
        :data="userLists"
        :reserve="true"
        :row-config="{ isCurrent: true, isHover: true }"
        :radio-config="{ strict: false, labelField: 'seq', trigger: 'row', isCurrent: true, isHover: true }"
      >
        <vxe-column type="radio" width="60" />
        <vxe-column :visible="false" field="id" title="用户id" />
        <vxe-column type="seq" title="序号" width="60" />
        <vxe-column field="name" title="用户名称" width="110" />
        <!-- <vxe-column field="roleNames" title="角色" /> -->
        <vxe-column field="department" title="所属组织结构" />
      </vxe-table>
      <vxe-pager
        :loading="userLoading"
        :current-page="addTablePage.currentPage"
        :page-size="addTablePage.pageSize"
        :total="addTablePage.totalResult"
        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
        @page-change="handlePageChange"
      />
      <span slot="footer" class="dialog-footer">
        <vxe-button @click="userDialogVisible = false">取 消</vxe-button>
        <vxe-button status="primary" @click="handleChooseUser()">确 定</vxe-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ActivityMaintenanceInformation from './MarketActivityComponents/ActivityMaintenanceInformation.vue'
import ActivityReportingInformation from './MarketActivityComponents/ActivityReportingInformation.vue'
import { findDealerActById, getActApplyDetail, getFiles, saveApproveInfo, findFileInfo, getPriceDiffApi } from '@/api/actPlan.js'
import { setInitImg } from '@/utils/Picture/transferFile'
import { approveStart, approveRestart, approveExecute, executeLastNode, executeAndJumpFirst, findTaskInfos, transfer, findDisTaskInfos } from '@/api/wf_process.js'
import { mapGetters } from 'vuex'
import { findList } from '@/api/user'
import { dateFormat } from '@/utils/DateUtils'

const defaultApproveType = new Map([
  [0, '发起审批'],
  [1, '同 意'],
  [2, '退回上一审批人'],
  [3, '驳 回'],
  [4, '转 派'],
  [5, '重新发起审批'],
  [6, '不同意']
])

const defautFactor = {
  code: '',
  symbol: '',
  values: ''
}

const defaultListQuery = {
  page: 1,
  limit: 10,
  importance: undefined,
  domain: 'center',
  title: undefined,
  type: undefined,
  conditions: [],
  sort: '+id'
}

export default {
  name: 'SignDetails',
  components: {
    ActivityMaintenanceInformation,
    // 活动提报信息
    ActivityReportingInformation
  },
  data() {
    return {
      loading: false,
      activityInfo: '',
      collapseNumber: 'default',
      findHistTasksData: [],
      fullscreenLoading: false,
      userLoading: false,
      approveBtnLoading: false,
      operatorUser: '',
      operatorId: '',
      userDialogVisible: false,
      approveMsg: '',
      approveValFalse: false,
      approveCost: '',
      pagination: {
        total: 0,
        size: 0,
        current: 0
      },
      userName: '',
      userLists: [],
      approveLoading: false,
      approveBtnType: '0',
      addTablePage: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0
      },
      factor: Object.assign({}, defautFactor),
      listQuery: Object.assign({}, defaultListQuery),
      approveTypeName: '确定',
      approveType: defaultApproveType,
      modelTableBase: {
        data: [],
        loading: false,
        selection: []
      },
      dialogVisible: false,
      activity: {},
      signData: {},
      showMain: true,
      fileInfoList: [],
      fileList: [],
      userinfo: {
        domain: 'dealer',
        id: ''  
      },
      priceDiff: {
        dealerDiff: null,
        areaDiff: null
      }
    }
  },
  computed: {
    // ...mapGetters(['userinfo'])
    ...mapGetters('account', ['user']),
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.operatorId = ''
        this.operatorUser = ''
        this.approveMsg = ''
        this.approveBtnLoading = false
      } else {
        this.approveCost = this.signData.approveApplyCost
      }
    }
  },
  created() {
    if (this.$route.params.id) {
      this.signData.id = this.$route.params.id
      // 获取提报详情
      this.getMarketactivityById(this.$route.params.id)
      console.log(this.activity,'activity')

      console.log(JSON.stringify(this.activity),'activity11')

      // 审核记录查询
      // http.findHistTasks({ businessId: this.signData.id }).then(val => {
      //   this.findHistTasksData = val.data
      // })
    }
  },
  methods: {
    // 获取提报详情
    getMarketactivityById(id) {
      this.loading = true
      getActApplyDetail(id).then(res => {
        if (res.code === 1 && res.data) {
          this.signData = res.data
          this.handleAppBtn()
          if (this.signData.applyStatus !== '0') {
            this.viewApproveDetail()
          }
          this.getActById(this.signData.planDealerId)
          this.getFileInfo(this.signData.planApplyCode)
          this.getPriceDiff('dealer')
          this.getPriceDiff('regionId')
          this.loading = false
        } else {
          this.$message.error(res.message)
          this.loading = false
        }
      })
    },
    // 获取文件信息
    getFileInfo(code) {
      findFileInfo(code).then(res => {
        if (res.code === 1 && res.data) {
          this.fileInfoList = res.data
          this.initFile()
        }
      })
    },
    ReturnFun2() {
      this.$deleteBeforeRouter(this)
      this.$router.go(-1)
    },
    initFile() {
      if (this.fileInfoList.length < 1) {
        return
      }
      this.fileInfoList.forEach(item => {
        if (item.module === 'actPlanApply') {
          this.fileList.push(item)
          // getFiles(item).then(res => {
          //   const file = setInitImg(res, item.name)
          //   this.fileList.push(file)
          // })
        }
      })
    },
    handleChooseUser() {
      const data = this.$refs['Xuser'].getRadioRecord()
      if (data) {
        this.operatorUser = data.name
        this.operatorId = data.id
      }
      this.userDialogVisible = false
    },
    chooseUser() {
      this.userDialogVisible = true
      this.findUsers()
    },
    handleFilter() {
      this.listQuery.page = 1
      this.factor.code = 'nameOrAccount'
      this.factor.values = this.userName
      this.listQuery.conditions[0] = this.factor
      this.findUsers()
    },
    findUsers() {
      this.userLoading = true
      findList(this.listQuery).then(res => {
        if (res.code === 1 && res.data) {
          this.userLists = res.data.list
          this.addTablePage.totalResult = res.data.total
          this.userLoading = false
        }
      })
    },
    viewApproveDetail() {
      const param = {
        orderId: this.signData.applyOrderId || this.signData.applyHistOrderId
      }
      this.approveLoading = true
      if (this.signData.applyStatus === '4') {
        findDisTaskInfos(param).then(res => {
          this.findHistTasksData = res.data
          this.approveLoading = false
        })
      } else {
        findTaskInfos(param).then(res => {
          if (res.code === 1 && res.data) {
            this.findHistTasksData = res.data
            this.findHistTasksData.forEach(item => {
              if (!item.his) {
                item.operatorName = this.signData.applyAuditorNames
                item.finishTime = '正在处理'
              }
            })
            this.approveLoading = false
          }
        })
      }
    },
    handlePageChange({ currentPage, pageSize }) {
      this.addTablePage.currentPage = currentPage
      this.addTablePage.pageSize = pageSize
      this.listQuery.limit = pageSize
      this.listQuery.page = currentPage
      this.findUsers()
    },
    handleAppBtn() {
      if (this.signData.applyStatus === '0') {
        this.approveBtnType = '1'
      }
      if (this.signData.applyStatus === '1' &&
      this.signData.applyAuditorIds.indexOf(this.user.userId) !== -1) {
        this.approveBtnType = '2'
      }
      if (this.signData.applyStatus === '3' &&
       (this.user.userId == this.signData.applyAuditorIds || this.signData.applyAuditorIds == null)) {
        this.approveBtnType = '3'
      }
    },
    // 获取活动详情
    getActById(id) {
      const data = {
        id: id,
        planApplyId: this.signData.id
      }
      findDealerActById(data).then(res => {
        if (res.code === 1 && res.data) {
          this.activity = res.data
          this.signData.dealerName = this.activity.dealerName
          this.signData.dealerShortName = this.activity.dealerShortName
          console.log(this.activity,'activity222222')
          console.log(JSON.stringify(this.activity),'activity222222')
          console.log(JSON.stringify(this.activity.feeLimit),'activity222222')

        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 获取文件
    initFiles() {
      this.fileNames.forEach(name => {
        const data = { fileName: name }
        getFiles(data).then(res => {
          const file = setInitImg(res, name)
          this.fileList.push(file)
        })
      })
    },
    // lr0034  好像没效果
    gettotalCost() {
      if(this.approveTypeName === '退回上一审批人' || 
      this.approveTypeName === '驳 回' || 
      this.approveTypeName === '不同意'|| this.approveTypeName === '同意') {
        if(this.approveMsg){
          this.approveValFalse = false
        } else {
          this.approveValFalse = true
        }
      }
    },
    approve() {
      //  发起审批
      this.approveBtnLoading = true
      if (this.approveTypeName === '发起审批') {
        this.approveCost = this.signData.totalCost
        this.$store.dispatch('SelectData/QuerySelect', ['actProcessMap']).then(v => {
          v.actProcessMap.forEach(item => {
            if (item.code == this.activity.budgetTypeCode) {
              const approveParam = {
                processName: item.value,
                args: {
                  amounts: this.signData.totalCost,
                  approveMsg: this.approveMsg,
                  approveCost: this.approveCost,
                  businessCode: this.signData.planApplyCode,
                  businessName: this.signData.planApplyName
                }
              }
              approveStart(approveParam).then(res => {
                if (res.code === 1) {
                  this.$message.success('流程发起成功')
                  this.signData.applyFlowStart = dateFormat('YYYY-mm-dd HH:MM:SS', new Date())
                  this.signData.applyOrderId = res.data.orderId
                  this.signData.approveApplyCost = this.approveCost
                  this.signData.applyNode = res.data.approveNode
                  this.signData.applyStatus = '1'
                  this.signData.applyAuditorNames = res.data.operatorInfos[0].operatorNames
                  this.signData.applyAuditorIds = res.data.operatorInfos[0].operatorIds
                  saveApproveInfo(this.signData).then(v => {
                    this.approveBtnLoading = false
                    if (v.code === 1) {
                      this.dialogVisible = false
                      // this.reload()
                      this.ReturnFun()
                    }
                  })
                }
              })
            }
          })
        })
      }
      // 审批  lr0034
      if (this.approveTypeName === '同 意') {
        if (this.approveMsg === '') {
          this.approveBtnLoading = false
          // this.$message.warning('审批意见不能为空')
          this.approveValFalse = true
          return
        }
        if (this.approveCost === '') {
          this.$message.warning('审核金额不能为空')
          this.approveBtnLoading = false
          return
        }
        // if (this.approveCost > this.signData.approveApplyCost) {
        //   this.$message.warning('审核金额不能大于上一节点审核金额')
        //   this.approveBtnLoading = false
        //   return
        // }
        // 校验：审核金额不得超过合计（以提报预算 actBudget 作为合计上限）
        {
          const approveCostNum = Number(this.approveCost)
          const actBudgetNum = Number(this.signData.actBudget)
          if (!isNaN(actBudgetNum) && approveCostNum > actBudgetNum) {
            this.$message.warning('审核金额不能大于活动计划费用额度' + actBudgetNum.toFixed(2) + '元')
            this.approveBtnLoading = false
            return
          }
        }
        const approveParam = {
          orderId: this.signData.applyOrderId,
          processName: this.signData.activityApplyProcessName,  
          args: {
            amounts: this.signData.totalCost,
            approveMsg: this.approveMsg,
            approveCost: this.approveCost,
            businessCode: this.signData.planApplyCode,
            businessName: this.signData.planApplyName
          }
        }
        approveExecute(approveParam).then(res => {
          if (res.code === 1) {
            this.$message.success('审批成功')
            if (res.data.endFlg === true) {
              this.signData.applyStatus = '2'
              this.signData.writeoffStatus = '0'
              this.signData.approveApplyCost = this.approveCost
              this.signData.applyHistOrderId = res.data.orderId
            } else {
              this.signData.applyNode = res.data.approveNode
              this.signData.approveApplyCost = this.approveCost
              this.signData.applyAuditorNames = res.data.operatorInfos[0].operatorNames
              this.signData.applyAuditorIds = res.data.operatorInfos[0].operatorIds
            }
            saveApproveInfo(this.signData).then(v => {
              this.approveBtnLoading = false
              if (v.code === 1) {
                this.dialogVisible = false
                // this.$message.success('要返回上一级')
                // this.reload()
                this.ReturnFun()
              }
            })
          }
        })
      }
      // 退回上一步
      if (this.approveTypeName === '退回上一审批人') {
        if (this.approveMsg === '') {
          this.approveBtnLoading = false
          // this.$message.warning('审批意见不能为空')
          this.approveValFalse = true
          return
        }
        const approveParam = {
          orderId: this.signData.applyOrderId,
          args: {
            amounts: this.signData.totalCost,
            approveMsg: this.approveMsg,
            businessCode: this.signData.planApplyCode,
            businessName: this.signData.planApplyName
          }
        }
        executeLastNode(approveParam).then(res => {
          if (res.code === 1) {
            this.signData.applyNode = res.data.approveNode
            // 退回第一个节点，和驳回的逻辑一致
            if (res.data.firstNodeFlg === true) {
              this.signData.applyStatus = '3'
            }
            this.signData.applyAuditorNames = res.data.operatorInfos[0].operatorNames
            this.signData.applyAuditorIds = res.data.operatorInfos[0].operatorIds
            saveApproveInfo(this.signData).then(v => {
              this.approveBtnLoading = false
              if (v.code === 1) {
                this.dialogVisible = false
                // this.reload()
                this.ReturnFun()
              }
            })
          }
        })
      }
      // 驳回
      if (this.approveTypeName === '驳 回') {
        if (this.approveMsg === '') {
          this.approveBtnLoading = false
          // this.$message.warning('审批意见不能为空')
          this.approveValFalse = true
          return
        }
        const approveParam = {
          orderId: this.signData.applyOrderId,
          args: {
            amounts: this.signData.totalCost,
            approveMsg: this.approveMsg,
            businessCode: this.signData.planApplyCode,
            businessName: this.signData.planApplyName
          }
        }
        executeAndJumpFirst(approveParam).then(res => {
          if (res.code === 1) {
            this.signData.applyNode = res.data.approveNode
            this.signData.applyStatus = '3'
            this.signData.applyAuditorNames = res.data.operatorInfos[0].operatorNames
            this.signData.applyAuditorIds = res.data.operatorInfos[0].operatorIds
            saveApproveInfo(this.signData).then(v => {
              this.approveBtnLoading = false
              if (v.code === 1) {
                this.dialogVisible = false
                // this.reload()
                this.ReturnFun()
                
              }
            })
          }
        })
      }
      // 转派
      if (this.approveTypeName === '转 派') {
        if (this.approveMsg === '') {
          this.approveBtnLoading = false
          // this.$message.warning('审批意见不能为空')
          this.approveValFalse = true
          return
        }
        const approveParam = {
          orderId: this.signData.applyOrderId,
          operator: this.operatorId,
          args: {
            amounts: this.signData.totalCost,
            approveMsg: this.approveMsg,
            businessCode: this.signData.planApplyCode,
            businessName: this.signData.planApplyName
          }
        }
        transfer(approveParam).then(res => {
          if (res.code === 1) {
            this.signData.applyNode = res.data.approveNode
            this.signData.applyAuditorNames = res.data.operatorInfos[0].operatorNames
            this.signData.applyAuditorIds = res.data.operatorInfos[0].operatorIds
            saveApproveInfo(this.signData).then(v => {
              this.approveBtnLoading = false
              if (v.code === 1) {
                // this.reload()
                this.dialogVisible = false
                // this.reload()
                this.ReturnFun()
              }
            })
          }
        })
      }
      // 重新发起审批
      if (this.approveTypeName === '重新发起审批') {
        this.approveCost = this.signData.totalCost
        const approveParam = {
          orderId: this.signData.applyOrderId,
          processName: this.signData.activityApplyProcessName,  
          args: {
            amounts: this.signData.totalCost,
            approveCost: this.approveCost,
            approveMsg: this.approveMsg,
            businessCode: this.signData.planApplyCode,
            businessName: this.signData.planApplyName
          }
        }
        this.approveBtnLoading = true
        approveRestart(approveParam).then(res => {
          if (res.code === 1) {
            this.signData.applyStatus = '1'
            this.signData.applyNode = res.data.approveNode
            this.signData.approveApplyCost = this.approveCost
            this.signData.applyAuditorNames = res.data.operatorInfos[0].operatorNames
            this.signData.applyAuditorIds = res.data.operatorInfos[0].operatorIds
            saveApproveInfo(this.signData).then(v => {
              this.approveBtnLoading = false
              if (v.code === 1) {
                // this.reload()
                this.dialogVisible = false
                // this.reload()
                this.ReturnFun()
              }
            })
          }
        })
      }
      // 不同意，作废
      if (this.approveTypeName === '不同意') {
        if (this.approveMsg === '') {
          this.approveBtnLoading = false
          // this.$message.warning('审批意见不能为空')
          this.approveValFalse = true
          return
        }
        const approveParam = {
          orderId: this.signData.applyOrderId,
          disagree: '1',
          processName: this.signData.activityApplyProcessName,  
          args: {
            amounts: this.signData.totalCost,
            approveMsg: this.approveMsg,
            approveCost: this.approveCost,
            businessCode: this.signData.planApplyCode,
            businessName: this.signData.planApplyName
          }
        }
        approveExecute(approveParam).then(res => {
          if (res.code === 1) {
            this.signData.applyStatus = '4'
            this.signData.writeoffStatus = '0'
            this.signData.approveApplyCost = this.approveCost
            this.signData.applyHistOrderId = this.signData.applyOrderId
            saveApproveInfo(this.signData).then(v => {
              this.approveBtnLoading = false
              if (v.code === 1) {
                // this.reload()
                this.dialogVisible = false
                // this.reload()
                this.ReturnFun()
              }
            })
          }
        })
      }
    },
    handleApprove(type) {
      if (type === 0 && this.fileList.length < 1) {
        this.$message.warning('计划方案附件不能为空,请上传方案附件后发起审批')
        return
      }
      this.approveTypeName = this.approveType.get(type)
      this.dialogVisible = true
      this.approveValFalse = false
    },
    // 返回
    ReturnFun() {
      if(this.$route.query.type === 'myToDolistShiChangTiBao'){
        // 跳转路由
        this.$closePage('/terminalActivity/signDetails', '/terminalActivity/myToDolist')
      }else {
        // 跳转路由
        this.$closePage('/terminalActivity/signDetails', '/terminalActivity/signIndex')
      }
    },
    // 获取区域或经销商以补差
    async getPriceDiff(type) {
      let params
      if (type === 'dealer') {
        params = { dealerId: this.signData.dealerId}
        const res = await getPriceDiffApi(params)
        this.priceDiff.dealerDiff = res.data
      } else {
        params = { regionId: this.signData.regionId}
        const res = await getPriceDiffApi(params)
        this.priceDiff. areaDiff = res.data
      }
    }
  }
}
</script>
<style lang="less">
/deep/ .ant-message {
  z-index: 9999 !important; /* 选择一个比默认 z-index 更高的值 */
}
</style>
<style lang="less" scoped>

/deep/ .el-collapse-item__header {
  padding-left: 10px; 
}
.CertificateReleaseApplicationBox {
  width: 100%;
  overflow: auto;
  // padding: 0 5px;
  .elcolSpan {
    font-size: 12px;
    color: #606266;
    text-align: center;
  }
  .budgetBox {
    margin: 0 0 5px 0;
  }
}
.collapse-box {
  margin-top: 10px;
  border: 1px solid #cccccc;
}
.collapseItem {
  /deep/ .el-collapse-item__header {
    padding: 0px 20px;
    width: 100%;
    margin: 0;
    background: #0a76a4;
    color: #ffffff;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
  }
  /deep/ .el-collapse-item__content {
    padding-top: 20px;
    padding-right: 20px;
  }
}
.fixedButton {
  // padding: 0px 5px 0px;
  margin: 0 0 5px 0;
  border-bottom: 1px solid rgb(201, 201, 201);
  .examineButton {
    margin: 5px;
  }
}
</style>
